/** Decorative facets from the Option 1 concept, drawn as vectors for crisp rendering. */
export function BrandGeometry() {
  return (
    <svg className="brand-geometry" viewBox="0 0 600 900" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <path d="M-110 -100H600V390Z" fill="#006aff" fillOpacity=".27" />
      <path d="M290 -90H700V250C520 215 425 95 290 -90Z" fill="#008dff" fillOpacity=".25" />
      <path d="M-140 1020 660 420V650L100 1080Z" fill="#006cff" fillOpacity=".3" />
      <path d="M-90 960 660 398" stroke="#1e9bff" strokeOpacity=".45" />
      <path d="M-55 687 111 589 278 687 111 786Z" fill="#087cff" fillOpacity=".55" />
      <path d="M-55 687 111 786V977L-55 879Z" fill="#0053d5" fillOpacity=".65" />
      <path d="M111 786 278 687V879L111 977Z" fill="#0089ff" fillOpacity=".6" />
      <path d="M-8 793 156 696 319 793 156 890Z" fill="#0585ff" fillOpacity=".45" />
      <path d="M156 890 319 793V985L156 1082Z" fill="#0057d8" fillOpacity=".5" />
    </svg>
  );
}
